import React from 'react';
import { ArrowRight, CheckCircle, Sparkles } from 'lucide-react';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const element = document.querySelector(sectionId);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="relative pt-32 pb-20 overflow-hidden bg-gradient-to-br from-gray-50 via-white to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="space-y-8 animate-fade-in">
            <div className="inline-block">
              <span className="text-[#1A3E6E] font-semibold text-sm uppercase tracking-wide bg-orange-50 px-4 py-2 rounded-full flex items-center gap-2">
                <Sparkles size={16} />
                AI-Powered Software Solutions
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
              Transform Business with
              <span className="text-[#1A3E6E]"> AI & Innovation</span>
            </h1>
            
            <p className="text-xl text-gray-600 leading-relaxed">
              OneIT Solutions delivers cutting-edge AI solutions, full-stack development, and top-tier tech talent. 
              From machine learning to cloud infrastructure, we build the future of software.
            </p>

            <div className="space-y-3">
              {[
                'AI & Machine Learning Solutions',
                'Full-Stack Software Development',
                'Data Science & Analytics',
                'Cloud & DevOps Engineering',
                'Elite Tech Talent Staffing'
              ].map((item, index) => (
                <div key={index} className="flex items-center space-x-3">
                  <CheckCircle className="text-[#1A3E6E] flex-shrink-0" size={20} />
                  <span className="text-gray-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <Button
                onClick={() => scrollToSection('#contact')}
                className="bg-[#1A3E6E] hover:bg-[#1A3E6E] text-white px-8 py-6 text-lg rounded-md transition-all duration-200 flex items-center justify-center group"
              >
                Get Started
                <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={20} />
              </Button>
              <Button
                onClick={() => navigate('/services/ai-solutions')}
                variant="outline"
                className="border-2 border-gray-300 hover:border-[#1A3E6E] text-gray-700 hover:text-[#1A3E6E] px-8 py-6 text-lg rounded-md transition-all duration-200"
              >
                Explore AI Solutions
              </Button>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative lg:block hidden">
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1694903110330-cc64b7e1d21d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwzfHxhcnRpZmljaWFsJTIwaW50ZWxsaWdlbmNlfGVufDB8fHx8MTc2MzkzMTUwOXww&ixlib=rb-4.1.0&q=85"
                alt="AI Technology"
                className="w-full h-full object-cover"
              />
            </div>
            {/* Decorative Elements */}
            <div className="absolute -top-4 -right-4 w-72 h-72 bg-orange-100 rounded-full opacity-20 blur-3xl"></div>
            <div className="absolute -bottom-4 -left-4 w-72 h-72 bg-orange-50 rounded-full opacity-30 blur-3xl"></div>
          </div>
        </div>
      </div>

      {/* Wave Divider */}
      <div className="absolute bottom-0 left-0 right-0">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 120" className="w-full h-auto">
          <path fill="#ffffff" d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z"></path>
        </svg>
      </div>
    </section>
  );
};

export default Hero;
